import { render, staticRenderFns } from "./UpdateInternationProduct.vue?vue&type=template&id=22ba4111&scoped=true&"
import script from "./UpdateInternationProduct.vue?vue&type=script&lang=js&"
export * from "./UpdateInternationProduct.vue?vue&type=script&lang=js&"
import style0 from "./UpdateInternationProduct.vue?vue&type=style&index=0&id=22ba4111&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ba4111",
  null
  
)

export default component.exports